var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-page-footer"},[_c('div',{staticClass:"match-page-footer-pc"},[_c('DownloadGameFooter',{staticClass:"footer--match-theme"})],1),_c('div',{staticClass:"match-page-footer-mobile"},[_c('DownloadGameFooterMobile',{staticClass:"footer--match-theme"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }